import Model from "../../Model";

export interface TGiftAndDonation {
  applicantId: number;
  recipientName: string;
  giverName: string;
  giftType: string;
  value: string;
  description: string;
  receivingDate: string;
}

export interface IGiftAndDonation extends TGiftAndDonation {}

const GiftAndDonation = Model(
  (model: TGiftAndDonation): IGiftAndDonation => {
    const _giftAndDonation: TGiftAndDonation = Object.assign({}, model);

    return {
      get applicantId() {
        return _giftAndDonation.applicantId;
      },

      get recipientName() {
        return _giftAndDonation.recipientName;
      },

      get giverName() {
        return _giftAndDonation.giverName;
      },

      get giftType() {
        return _giftAndDonation.giftType;
      },

      get value() {
        return _giftAndDonation.value;
      },

      get description() {
        return _giftAndDonation.description;
      },

      get receivingDate() {
        return _giftAndDonation.receivingDate;
      }
    };
  }
);
export default GiftAndDonation;
